import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// 标签知识卡片索引
interface TagKnowledgeIndex {
  [tagName: string]: number; // 标签名 -> 知识卡片ID的映射
}

interface State {
  tags: string[];
  tagCounts: Record<string, number>;
  knowledgeIndex: TagKnowledgeIndex;
}

const tagSlice = createSlice({
  name: "tag",
  initialState: {
    tags: [],
    tagCounts: {},
    knowledgeIndex: {},
  } as State,
  reducers: {
    setTags: (state, action: PayloadAction<string[]>) => {
      return {
        ...state,
        tags: action.payload,
      };
    },
    setTagsCnt: (state, action: PayloadAction<Record<string, number>>) => {
      return {
        ...state,
        tagCounts: action.payload,
      };
    },
    upsertTag: (state, action: PayloadAction<string>) => {
      if (state.tags.includes(action.payload)) {
        return state;
      }

      return {
        ...state,
        tags: state.tags.concat(action.payload),
      };
    },
    deleteTag: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        tags: state.tags.filter((tag) => {
          return tag !== action.payload;
        }),
      };
    },
    // 添加知识索引相关的reducer
    setKnowledgeIndex: (state, action: PayloadAction<TagKnowledgeIndex>) => {
      return {
        ...state,
        knowledgeIndex: action.payload,
      };
    },
    updateKnowledgeIndexItem: (state, action: PayloadAction<{ tagName: string; memoId: number }>) => {
      const { tagName, memoId } = action.payload;
      return {
        ...state,
        knowledgeIndex: {
          ...state.knowledgeIndex,
          [tagName]: memoId,
        },
      };
    },
    removeKnowledgeIndexItem: (state, action: PayloadAction<string>) => {
      const newKnowledgeIndex = { ...state.knowledgeIndex };
      delete newKnowledgeIndex[action.payload];
      return {
        ...state,
        knowledgeIndex: newKnowledgeIndex,
      };
    },
  },
});

export const { setTags, upsertTag, deleteTag, setTagsCnt, setKnowledgeIndex, updateKnowledgeIndexItem, removeKnowledgeIndexItem } =
  tagSlice.actions;

export default tagSlice.reducer;
